import { CheckIcon } from 'assets/icons/CheckIcon'
import Chevron from 'assets/icons/Chevron'
import { PendingIcon } from 'assets/icons/PendingIcon'
import { StopIcon } from 'assets/icons/StopIcon'
import { FilterEnum, IFilter } from 'components/Filter/SingleFilter'
import { NavBar } from 'components/NavBar/NavBar'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Pagination } from 'components/Pagination/Pagination'
import { Td } from 'components/Td/Td'
import { endOfWeek } from 'date-fns/esm'
import { clearDBWorkflows, getDBWorkflows, getDBWorkflowsInfo } from 'features/dashboard/dbTasksSlice'
import { ISingleDBWorkflow } from 'features/dashboard/types'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootState } from 'store'
import { EditContainer, Flex, H1WithBack, PageControls, PageFooter, PageWrapper, SubsContainer, Table, Th, Tr, TrChevronContainer, TrContentContainer } from 'styling/GlobalStyles'
import { convertToDate, getParams, getTime } from 'utils/helpers'
import { DBCardsContainer } from '../Dashboard.styled'
import { taskStatusesData } from '../dashboardData'
import { DBTaskCard, DBTCDetails, DBTCIcon } from './DBTasks.styled'
import { WorkflowIcon } from 'assets/icons/WorkflowIcon'
import { ArrowLeft } from 'assets/icons/ArrowLeft'
import { Heading1, OtherText, TitleText } from 'styling/Typography'
import CalendarInput from 'components/CalendarInput/CalendarInput'

export const DBWorkflows = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const [params, setParams] = useState<any>(getParams({
        location, ap: {
            dateFrom: new Date(searchParams.get('dateFrom') ?? new Date()),
            dateTo: searchParams.get('dateTo') ? new Date(searchParams.get('dateTo')) : endOfWeek(new Date(), { weekStartsOn: 1 }),
        },
        localeDateString: true
    }))
    const [page, setPage] = useState(1)
    const navigate = useNavigate()
    const { noWorkflows, workflows, workflowsInfo } = useSelector((state: RootState) => state.dbTasks)

    useQueryPagination({ fetchFunctions: [getDBWorkflows, getDBWorkflowsInfo], cleanUpFunctions: [clearDBWorkflows], params })

    const getPage = (arr: any[]) => {
        const startIndex = (page - 1) * 5;
        const endIndex = startIndex + 5;

        return arr?.slice(startIndex, endIndex);
    }

    const setDateFrom = (value) => {
        setParams(prev => {
            const copy = structuredClone(prev)
            copy.dateFrom = convertToDate(value)
            return copy
        })
    }

    const setDateTo = (value) => {
        setParams(prev => {
            const copy = structuredClone(prev)
            copy.dateTo = convertToDate(value)
            return copy
        })
    }

    const filters: IFilter[] = [
        {
            type: FilterEnum.FIXED_LIST,
            name: 'Difference',
            state: null,
            propName: 's',
            sd: true,
            single: true,
            filterOptions: [
                {
                    name: 'Cost - From Low To High',
                    id: 'costDifference-a'
                },
                {
                    name: 'Cost - From High To Low',
                    id: 'costDifference-d'
                },
                {
                    name: 'Duration - From Low To High',
                    id: 'durationDifference-a'
                },
                {
                    name: 'Duration - From High To Low',
                    id: 'durationDifference-d'
                },
            ]
        },
        {
            type: FilterEnum.SELECT,
            name: 'Status',
            options: taskStatusesData.map(s => ({ label: s.name, value: s.id })),
            propName: 'status'
        },

    ]


    const TaskRow = ({ task, sub, location }: { task: ISingleDBWorkflow, sub?: boolean, location?: string }) => {
        const [open, setOpen] = useState(false)

        return < Tr hasSubs={true} sub={sub} open={open} overflowHidden={!open} pointer onClick={!sub ? () => setOpen(!open) : () => navigate('/dashboard/tasks/' + task.id)} >
            <TrContentContainer>
                <Td w='15%' text={task?.template ? task.template.name : task.name} />
                <Td w='18%' text={location ?? '-'} />
                <Td w='18%'>
                    <p>
                        {'$ ' + (task?.actualCost ? task.actualCost.toFixed(2) : '/')}
                    </p>
                </Td>
                <Td w='15%'>
                    {task?.totalDuration ? getTime(task?.totalDuration) : '-'}
                </Td>
                <Td w='10%'>
                    <p style={(task?.status == 4 || task?.status == 3 || task?.status == 7) ? { color: task?.status == 3 ? '#00B04C' : '#F00' } : {}} >
                        {taskStatusesData.find(s => s.id == task.status).name}
                    </p>
                </Td>
                <Td w='15%' >
                    <p style={task?.issue ? { color: '#F00' } : {}} >{task?.issue || '-'}</p>

                </Td>
                <Td action w='5%' >
                    {!sub ? <TrChevronContainer open={open}>
                        <Chevron />
                    </TrChevronContainer> : <Td noTooltip>
                        <EditContainer onClick={() => navigate('/dashboard/tasks/' + task.id)} >
                            <Flex style={{ transform: 'rotate(180deg)' }} className='arrow-table' >
                                <ArrowLeft />
                            </Flex>
                        </EditContainer>
                    </Td>}
                </Td>

            </TrContentContainer>
            <SubsContainer>
                {task.tasks.map((t, i) => <TaskRow sub={true} key={i} location={t.location.name} task={
                    {
                        name: t.template.name,
                        actualCost: t.actualCost,
                        status: t.status,
                        issue: t.issue,
                        totalDuration: t.totalDuration,
                        tasks: [],
                        id: t.id,
                        template: null

                    }} />)}
            </SubsContainer>

        </Tr>

    }
    return <>
        <NavBar filterOptions={filters} setParams={setParams} params={params} />
        <PageWrapper>
            <Flex between center mb='16'>
                <H1WithBack title='Workflows' arrow link='/dashboard' />
                <Flex gap='1rem' center>
                    <CalendarInput
                        maxDate={new Date(params.dateTo)}
                        labelText='Start date'
                        defaultValue={new Date(params.dateFrom || new Date())}
                        onChange={v => setDateFrom(v)}
                    />
                    <CalendarInput
                        minDate={new Date(params.dateFrom)}
                        labelText='End date'
                        defaultValue={new Date(params.dateTo || new Date())}
                        onChange={v => setDateTo(v)}
                    />
                </Flex>
            </Flex>
            <DBCardsContainer>
                <DBTaskCard>
                    <DBTCIcon>
                        {WorkflowIcon}
                    </DBTCIcon>
                    <DBTCDetails>
                        <TitleText weight='bold' >Total Workflows</TitleText>
                        <Heading1 color='#ff9900' weight='bold' >{workflowsInfo?.totalCount || 0}</Heading1>
                        <Flex column>
                            <OtherText>{'Total Costs: $' + (workflowsInfo?.totalActualCost?.toFixed(2) ?? 0)}</OtherText>
                            <OtherText>{'Total Duration: ' + getTime(workflowsInfo?.totalDuration)}</OtherText>
                        </Flex>
                    </DBTCDetails>
                </DBTaskCard>
                <DBTaskCard>
                    <DBTCIcon>
                        {PendingIcon}
                    </DBTCIcon>
                    <DBTCDetails next >
                        <TitleText weight='bold' >Total In Progress</TitleText>
                        <Heading1 color='#ff9900' weight='bold' >{workflowsInfo?.totalInProgressCount || 0}</Heading1>
                    </DBTCDetails>
                </DBTaskCard>
                <DBTaskCard>
                    <DBTCIcon>
                        {StopIcon}
                    </DBTCIcon>
                    <DBTCDetails>
                        <TitleText weight='bold' >Total Stopped</TitleText>
                        <Heading1 color='#ff9900' weight='bold' >{workflowsInfo?.totalStoppedCount || 0}</Heading1>
                        <Flex column>
                            <OtherText>{'Total Costs: $' + (workflowsInfo?.totalStoppedActualCost ?? 0)}</OtherText>
                            <OtherText>{'Total Duration: ' + getTime(workflowsInfo?.totalStoppedDuration)}</OtherText>
                        </Flex>
                    </DBTCDetails>
                </DBTaskCard>
                <DBTaskCard>
                    <DBTCIcon>
                        {CheckIcon}
                    </DBTCIcon>
                    <DBTCDetails>
                        <TitleText weight='bold'>Total Completed</TitleText>
                        <Heading1 color='#ff9900' weight='bold' >{workflowsInfo?.totalCompletedCount || 0}</Heading1>
                        <Flex column>
                            <OtherText>{'Total Costs: $' + (workflowsInfo?.totalCompletedActualCost ?? 0)}</OtherText>
                            <OtherText>{'Total Duration: ' + getTime(workflowsInfo?.totalCompletedDuration)}</OtherText>
                        </Flex>
                    </DBTCDetails>
                </DBTaskCard>
            </DBCardsContainer>
            {noWorkflows ? <NoItems marginTop='40px' title='Workflows' /> : <Table style={{ marginTop: '40px' }} >
                <Th next >
                    <Td w='15%' noTooltip text='Workflow Name' />
                    <Td w='18%' noTooltip text='Location' />
                    <Td w='18%' noTooltip text='Cost' />
                    <Td w='15%' noTooltip text='Duration' />
                    <Td w='10%' noTooltip text='Status' />
                    <Td w='15%' noTooltip text='Alerts' />
                </Th>

                {
                    getPage(workflows)?.map((item: ISingleDBWorkflow) => {
                        let location = item.tasks[0].location.name
                        if (!item.tasks.every(t => t.location.name == location)) {
                            location = 'Multiple locations'
                        }
                        return <TaskRow task={item} location={location} key={item.id} />
                    })
                }
            </Table>}
        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => setPage(page)}
                pageCount={Math.ceil(workflows.length / 5)}
                forcePage={(page ? page : 1) - 1}
            />
        </PageFooter>
    </>
}